import { Alert, Link as MuiLink, Typography } from '@mui/material'
import { useCallback, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import Dialog from '../../Common/Dialog/Dialog'
import DialogContent from '../../Common/Dialog/DialogContent'
import DialogTitle from '../../Common/Dialog/DialogTitle'
import tKey from '../../Common/Utils/tKey'

export default function NaturalFabricDelayNotice() {
  const [t] = useTranslation('cart')
  const [dialogOpened, setDialogOpened] = useState(false)

  const onDialogOpen = useCallback(() => {
    setDialogOpened(true)
  }, [])

  const onDialogClose = useCallback(() => {
    setDialogOpened(false)
  }, [])

  return <>
    <Alert severity="warning">
      <Trans
        t={t}
        i18nKey={tKey('Due to a system issue, there is a 1 week delay for products in natural fabrics. <a>Learn more</a>')}
        components={{
          a: <MuiLink component="button" onClick={onDialogOpen} />
        }}
      />
    </Alert>

    <Dialog
      open={dialogOpened}
      maxWidth="sm"
      fullWidth
      onClose={onDialogClose}
      showCloseButton
    >
      <DialogTitle>{t('Natural fabric production delay')}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" component="p">
          {t('A temporary issue affecting our natural printing systems is delaying production on products made from natural fabrics by about 1 week. To avoid the delay, you can change your fabric option to be one of our polyester options. Tea towels, duvet covers, tapestries, or bed pillow cases unfortunately do not have polyester options and will need to remain in queue until the system is back up. If you are selling natural fabric products via an integration like Etsy or Shopify, we recommend you extend the production time.')}
        </Typography>
      </DialogContent>
    </Dialog>
  </>
}
